/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface V1CreateBusinessProfileAndSuggestPoiButtonSection
 */
export interface V1CreateBusinessProfileAndSuggestPoiButtonSection {
    /**
     * 
     * @type {string}
     * @memberof V1CreateBusinessProfileAndSuggestPoiButtonSection
     */
    createBusinessProfileTargetUri: string;
    /**
     * 
     * @type {string}
     * @memberof V1CreateBusinessProfileAndSuggestPoiButtonSection
     */
    suggestPoiTargetUri: string;
}

/**
 * Check if a given object implements the V1CreateBusinessProfileAndSuggestPoiButtonSection interface.
 */
export function instanceOfV1CreateBusinessProfileAndSuggestPoiButtonSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createBusinessProfileTargetUri" in value;
    isInstance = isInstance && "suggestPoiTargetUri" in value;

    return isInstance;
}

export function V1CreateBusinessProfileAndSuggestPoiButtonSectionFromJSON(json: any): V1CreateBusinessProfileAndSuggestPoiButtonSection {
    return V1CreateBusinessProfileAndSuggestPoiButtonSectionFromJSONTyped(json, false);
}

export function V1CreateBusinessProfileAndSuggestPoiButtonSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1CreateBusinessProfileAndSuggestPoiButtonSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createBusinessProfileTargetUri': json['create_business_profile_target_uri'],
        'suggestPoiTargetUri': json['suggest_poi_target_uri'],
    };
}

export function V1CreateBusinessProfileAndSuggestPoiButtonSectionToJSON(value?: V1CreateBusinessProfileAndSuggestPoiButtonSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'create_business_profile_target_uri': value.createBusinessProfileTargetUri,
        'suggest_poi_target_uri': value.suggestPoiTargetUri,
    };
}

